import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { withMediaAnalyticsContext } from '@atlaskit/media-common';
import { UnhandledErrorCard } from './ui/unhandledErrorCard';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireMediaCardEvent } from '../utils/analytics';
var WrappedMediaCardAnalyticsErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function WrappedMediaCardAnalyticsErrorBoundary(props) {
    var _this;
    _classCallCheck(this, WrappedMediaCardAnalyticsErrorBoundary);
    _this = _callSuper(this, WrappedMediaCardAnalyticsErrorBoundary, [props]);
    _defineProperty(_this, "fireOperationalEvent", function (error, info) {
      var _window;
      var _this$props = _this.props,
        _this$props$data = _this$props.data,
        data = _this$props$data === void 0 ? {} : _this$props$data,
        createAnalyticsEvent = _this$props.createAnalyticsEvent;
      var payload = {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: _objectSpread({
          browserInfo: (_window = window) !== null && _window !== void 0 && (_window = _window.navigator) !== null && _window !== void 0 && _window.userAgent ? window.navigator.userAgent : 'unknown',
          error: error,
          info: info,
          failReason: 'unexpected-error'
        }, data)
      };
      fireMediaCardEvent(payload, createAnalyticsEvent);
    });
    _defineProperty(_this, "handleOnClick", function (event) {
      try {
        var _this$props$onClick, _this$props2;
        (_this$props$onClick = (_this$props2 = _this.props).onClick) === null || _this$props$onClick === void 0 || _this$props$onClick.call(_this$props2, {
          event: event
        });
      } catch (e) {}
    });
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _inherits(WrappedMediaCardAnalyticsErrorBoundary, _React$Component);
  return _createClass(WrappedMediaCardAnalyticsErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      try {
        this.fireOperationalEvent(error, info);
      } catch (e) {}
      this.setState({
        hasError: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var hasError = this.state.hasError;
      var _this$props3 = this.props,
        dimensions = _this$props3.dimensions,
        children = _this$props3.children;
      if (hasError) {
        return /*#__PURE__*/React.createElement(UnhandledErrorCard, {
          dimensions: dimensions,
          onClick: this.handleOnClick
        });
      }
      return children;
    }
  }]);
}(React.Component);
_defineProperty(WrappedMediaCardAnalyticsErrorBoundary, "displayName", 'MediaCardAnalyticsErrorBoundary');
var packageName = "@atlaskit/media-card";
var packageVersion = "79.2.3";

// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
var MediaCardAnalyticsErrorBoundary = withMediaAnalyticsContext({
  packageVersion: packageVersion,
  packageName: packageName,
  componentName: 'mediaCard',
  component: 'mediaCard'
})(withAnalyticsEvents()(WrappedMediaCardAnalyticsErrorBoundary));
export default MediaCardAnalyticsErrorBoundary;